import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5","key":"svg-0"}],["path",{"d":"M3 10h18","key":"svg-1"}],["path",{"d":"M10 3v18","key":"svg-2"}],["path",{"d":"M16 19h6","key":"svg-3"}],["path",{"d":"M19 16v6","key":"svg-4"}]]

const IconTablePlus = createReactComponent('outline', 'table-plus', 'TablePlus', __iconNode);

export default IconTablePlus;